import { render, staticRenderFns } from "./TeflSalaryGuide.vue?vue&type=template&id=7d400e7e&"
import script from "./TeflSalaryGuide.vue?vue&type=script&lang=js&"
export * from "./TeflSalaryGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormsGuides: require('/opt/build/repo/components/Forms/Guides.vue').default})
